'use strict';

import { getLoginRequiredResolveObj } from '../shared/utils/angularUtils';
import { NAVIGATION_ICON } from '../shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../shared/constants/user-info/solutionType';

export const notesModule = angular
  .module('app.notes', [])
  .config(notesConfig);

notesConfig.$inject = ['$routeProvider'];

function notesConfig($routeProvider) {
  $routeProvider
    .when('/coach-notes', {
      template: '<ngz-coach-notes></ngz-coach-notes>',
      resolve: getLoginRequiredResolveObj(),
      pageConfig: {
        solution: SOLUTION_TYPE.NUTRITION,
        breadcrumbs: [
          { label: 'Notes', icon: NAVIGATION_ICON.DESCRIPTION }
        ]
      }
    });
}
